import React from 'react'
import Certificates from '../../components/certificates/Certificates'

const index = () => {
  return (
    <div>
        <Certificates />
    </div>
  )
}

export default index